export const en = {
    'request-error': 'An unexpected error occurred.'
};
